export default __webpack_public_path__ + "static/media/format-italic.33fae9d3.svg";